import { useState } from "react"
// import IMGBG1 from "../../assets/images/core/attract/bg1.png";
import IMGBG1 from "../../../assets/images/core/attract/bg1.png";
import IMGFeature1 from "../../../assets/images/core/attract/feature1.png";
import moment from "moment"

// const dst = moment().hour(11).minute(0).second(0)
// const det = moment().hour(15).minute(0).second(0)

export const Service = () => {
    const [templates, setTemplates] = useState({preview: {toggled: false}})
    const [calendar, setCalendar] = useState({modal: {toggled: false}, promo: ""})
    const [listCalendar, setListCalendar] = useState([])
    const [cloader, setCalendarLoader] = useState(false)
    const [dataCalendar, setDataCalendar] = useState({
            method: "create", 
            textModal: "",
            action: {
                myData: {
                    id: undefined,
                    date: "",
                    status: ""
                },
                modal: { toggled: false, confirmed: false, }
            }
        });
    // SERVICES
    const [promos, setPromos] = useState({list: null, current: {value: null, stat: false}, action: {selected: null, modal: false, type: 0, confirmed: false}})
    const [form, setForm] = useState({
        method: 'create',
        step: 1,
        pstatus: null,
        pid: null,
        submit: {modal: false, type: '', confirmed: false},
        inputs: {
            package_name: {value: '1 Day 1 Night Camping for 2', stat: false, msg: '', toggled: false},
            inclusions: [
                {value: 'Entrance Fee', stat: false, msg: '', toggled: false},
                {value: 'Tent for 2 Pax', stat: false, msg: '', toggled: false},
                {value: 'Mattress', stat: false, msg: '', toggled: false},
                {value: '2 Pillow and Blanket', stat: false, msg: '', toggled: false},
            ],
            rate: {value: '1360', stat: false, msg: '', toggled: false},
            discount: {value: '10', stat: false, msg: '', toggled: false},
            bg: {value: 'default_avatar', object: IMGBG1, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: true, msg: ''},
            logo: {value: null, object: null, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: true, msg: ''},
            title: {value: 'My Title', stat: false, msg: '', toggled: false},
            featured_image: {value: 'default_avatar', object: IMGFeature1, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: true, msg: ''},
            buttons: {
                first: {label: 'MORE INFO', link: '', stat: false, msg: '', stat_link: true, msg_link: '',},
                second: {label: 'BOOK NOW', link: '', stat: false, msg: '', toggled: false, color: ''}
            },
            location: {value: 'Sitio Ibucao, Brgy. Laiban, Tanay, Rizal', stat: false, msg: '', toggled: false},
            contact_num: {value: '09274459575', stat: false, msg: '', toggled: false},
            fb: {value: 'https://facebook.com/MiraAgroPark', stat: false, msg: '', toggled: false},
            promo_name: {value: '', stat: false, msg: '', toggled: false},
            start_date: {value: moment(new Date()).format('MM/DD/YYYY'), stat: false, msg: '', toggled: false},
            end_date: {value: '', stat: false, msg: '', toggled: false},
            days_per_promo: {value: '1', stat: false, msg: '', toggled: false},
            // start_time: {value: dst.format('YYYY-MM-DD HH:mm'), stat: false, msg: '', toggled: false},
            // end_time: {value: det.format('YYYY-MM-DD HH:mm'), stat: false, msg: '', toggled: false},
            partial: {value: '', stat: true, msg: '', toggled: false},
            check_in_time: [
                {start_time: '', end_time: '', stat: false, msg: ''},
            ],
            time: []
        }
    })
    const [reviewList, setRewivewList] = useState({promo: [], user: []})
    const [showReview, setShowReview] = useState({promo: false, user: false})
    const [viewLoader, setViewLoader] = useState(true)
    return {
        templates: {data: templates, set: setTemplates},
        form: {data: form, set: setForm},
        promos: {data: promos, set: setPromos},
        calendar: {data: calendar, set: setCalendar},
        listCalendar: {data: listCalendar, set: setListCalendar},
        cloader: {data: cloader, set: setCalendarLoader},
        dataCalendar: {data: dataCalendar, set: setDataCalendar},
        reviewList: {data: reviewList, set: setRewivewList},
        showReview: {data: showReview, set: setShowReview},
        viewLoader: {data: viewLoader, set: setViewLoader},
    }
}